import { render, staticRenderFns } from "./CancelarProcedimento.vue?vue&type=template&id=22ca78bf&"
import script from "./CancelarProcedimento.vue?vue&type=script&lang=js&"
export * from "./CancelarProcedimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports